export default __webpack_public_path__ + "static/logo_new_2026-1a47d9e336d74d69472b21223bf35057.png";